export default __webpack_public_path__ + "static/media/492.37bec7d8.png";